export default __webpack_public_path__ + "static/media/rebecca_stewart.1a14f935.jpg";